module.exports = __webpack_public_path__ + "static/BEEmptyBubble-b01f1339f7ffd1acf213b17097dd113e.png";